import { ParentTree, RecommendedTopics } from '@holmescorp/lcc-interfaces';
import { RpcService } from '@holmescorp/rpc';

export interface StudyPlanRequest {
	studyTrack: string;
	scores?: ParentTree;
	tgf_recommendations?: number;
}

export interface mlSvc extends RpcService {
	recommended_study_plan(params: StudyPlanRequest): Promise<RecommendedTopics>;
}

export const svc: mlSvc = new RpcService({
	transport: 'WEBSOCKET',
	envelope: 'JSON-RPC-2.0',
	strictParameters: false,
	target: `${window.hcstatic.portal_url}/@@ml.rpc`,

	services: {
		recommended_study_plan: {
			parameters: [
				{ name: 'studyTrack', type: 'string', optional: false },
				{ name: 'scores', type: 'object', optional: true },
				{ name: 'tgf_recommendations', type: 'int', optional: true }
			]
		}
	}
}) as mlSvc;

export default svc;
